import React from 'react';
import classNames from 'classnames';
import './Message.styles.scss';

type MessageProps = {
  show: boolean,
  children: React.ReactNode
}
const Message = ({show, children}: MessageProps) => {
  return (
    <div className="message-wrapper">
      <h2 className={classNames('message', {show})}>{children}</h2>
    </div>
  )
}

export default Message;
